<template>
    <button
        class="button-search"
        @click="$emit('click')"
        >
        <icon class="icon-search" name="search" :size="15"/>
    </button>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
.button-search
    display: block
    width: 35.42px
    height: 35px
    border-radius: 20px
    background-color: #00995d
    color: #FFF
    cursor: pointer
    position: relative

.icon-search
    position: absolute
    left: 10px
    top: 8px

</style>
